import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "style-list" }
const _hoisted_2 = { class: "style-list" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "关联风格", -1)
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_editor_upload = _resolveComponent("editor-upload")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_StyleInput = _resolveComponent("StyleInput")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.localVisible,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localVisible) = $event)),
    title: "创建榜单"
  }, {
    footer: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.localVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.doConfirmEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])), [
        [_directive_loading, _ctx.formLoading]
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "createRank",
        model: _ctx.formEdit,
        "status-icon": "",
        "label-width": "80px",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              label: "标题",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formEdit.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formEdit.title) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述",
              prop: "desc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formEdit.desc,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formEdit.desc) = $event)),
                  type: "textarea",
                  rows: 2
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "图片",
              prop: "primary_img"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_editor_upload, {
                  modelValue: _ctx.formEdit.primary_img,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formEdit.primary_img) = $event)),
                  "record-id": _ctx.formEdit._id
                }, null, 8, ["modelValue", "record-id"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.type.index,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formEdit.type.index) = $event)),
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 艺人榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.type.index,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formEdit.type.index) = $event)),
                  label: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 专辑榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "主题",
              prop: "topic"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.topic.index,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formEdit.topic.index) = $event)),
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 风格榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.topic.index,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formEdit.topic.index) = $event)),
                  label: 11
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 年代榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.topic.index,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formEdit.topic.index) = $event)),
                  label: 12
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 年榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.topic.index,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formEdit.topic.index) = $event)),
                  label: 21
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 主题榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formEdit.topic.index,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formEdit.topic.index) = $event)),
                  label: 22
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 地区榜 ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, [
              _createVNode(_component_StyleInput, {
                multiple: true,
                styles: _ctx.formEdit.styles,
                onChange: _ctx.onChooseStyle
              }, null, 8, ["styles", "onChange"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"])), [
    [_directive_loading, _ctx.formLoading]
  ])
}